export default __webpack_public_path__ + "static/media/storage.c45882a0.svg";